"use client";

import { motion } from "framer-motion";
import { FaRocket, FaUserClock, FaLightbulb, FaHandshake } from "react-icons/fa";

const features = [
  {
    icon: <FaRocket />,
    title: "Fast Delivery",
    description: "We deliver projects on time without compromising quality."
  },
  {
    icon: <FaUserClock />,
    title: "24/7 Support",
    description: "Round-the-clock technical support for your peace of mind."
  },
  {
    icon: <FaLightbulb />,
    title: "Innovative Solutions",
    description: "Cutting-edge technologies and innovative approaches to solve complex problems."
  },
  {
    icon: <FaHandshake />,
    title: "Trusted Partner",
    description: "Long-term partnerships built on trust and mutual success."
  }
];

export default function WhyChooseUs() {
  return (
    <section className="py-12 sm:py-16 md:py-20">
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4">Why Choose Us</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base sm:text-lg">
            We combine technical expertise with business acumen to deliver solutions that drive your success.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center p-6 sm:p-8 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="bg-primary/10 w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-primary text-xl sm:text-2xl">
                {feature.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3">{feature.title}</h3>
              <p className="text-gray-600 text-sm sm:text-base">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}